module.exports = __webpack_public_path__ + "img/help14.9d7d4f96.png";